import { gql } from '@apollo/client';
import GROUPS_FRAGMENT from 'graph/fragments/groups';

import STUDENT_FRAGMENT from '../fragments/student';

export default gql`
  mutation updateStudentMutation($where: StudentWhereInput!, $data: StudentUpdateInput!) {
    updateStudent(data: $data, where: $where) {
      ...BaseStudent
      groups {
        ...BaseGroups
      }
    }
  }
  ${STUDENT_FRAGMENT}
  ${GROUPS_FRAGMENT}
`;
